import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ShipService {
  private apiUrl = '/ships';
  private apiPlayUrl = '/play/ships';
  private apiSpringUrl = '/spring/ships';
  private resultmailsendApiUrl = '/spring/resultmailsend/RA3010';

  constructor(private http: HttpService) { }

  get(query?: any): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    return this.http.get(url, query);
  }

  post(data: any): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl;
    return this.http.post(url, data);
  }

  del(shipHId: number[]): Promise<any> {
    // Play API
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/delete`;
    return this.http.post(url, { shiphIdList: shipHId });
  }

  checkShort(ownerId: number, selectItems: object[], updprogramCd: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/short`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < selectItems.length; i++) {
      jsonUnit.push({
        shiphId: selectItems[i]['shiphId']
      });
    }
    const jsonInput: object = { ownerId: ownerId, selectItems: jsonUnit, updprogramCd: updprogramCd };
    return this.http.post(url, jsonInput);
  }

  checkShortDetail(ownerId: number, selectItems: object[], updprogramCd: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/short/detail`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < selectItems.length; i++) {
      jsonUnit.push({
        shiphId: selectItems[i]['shiphId']
      });
    }
    const jsonInput: object = { ownerId: ownerId, selectItems: jsonUnit, updprogramCd: updprogramCd };
    return this.http.post(url, jsonInput);
  }

  apply(ownerId: number, selectItems: object[], doPickBreak: boolean, doMultiPick: boolean, updprogramCd: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + this.apiSpringUrl}/apply`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < selectItems.length; i++) {
      jsonUnit.push({
        shiphId: selectItems[i]['shiphId']
      });
    }
    const jsonInput: object = { ownerId: ownerId, selectItems: jsonUnit, doPickBreak: doPickBreak, doMultiPick: doMultiPick, updprogramCd: updprogramCd };
    return this.http.post(url, jsonInput);
  }

  updateDeli(
    ownerId: number,
    shiphId: number,
    shipDt: string,
    carrierCd: string,
    dtaddressId: number,
    dtpostalCd: string,
    dtprefCd: string,
    dtaddress1Tx: string,
    dtaddress2Tx: string,
    dtaddress3Tx: string,
    dtaddress4Tx: string,
    dtnameTx: string,
    dttelTx: string,
    rqnameTx: string,
    delidateTx: string,
    delitimeCd: string,
    memoTx: string,
    updprogramCd: string,
    updcounterNr: number
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/deli/${shiphId}`;

    /*
        let shipDt2 = '';
        if (shipDt !== undefined && shipDt !== '') {
          const shipDate = new Date(shipDt);
          shipDt2 = shipDate.getFullYear() + '/' + ('0' + (shipDate.getMonth() + 1)).slice(-2) + '/' + ('0' + shipDate.getDate()).slice(-2)
        }
    */
    const jsonInput = {
      ownerId: ownerId,
      shipDt: shipDt,
      carrierCd: carrierCd,
      dtaddressId: dtaddressId,
      dtpostalCd: dtpostalCd,
      dtprefCd: dtprefCd,
      dtaddress1Tx: dtaddress1Tx,
      dtaddress2Tx: dtaddress2Tx,
      dtaddress3Tx: dtaddress3Tx,
      dtaddress4Tx: dtaddress4Tx,
      dtnameTx: dtnameTx,
      dttelTx: dttelTx,
      delidateTx: delidateTx,
      delitimeCd: delitimeCd,
      rqnameTx: rqnameTx,
      memoTx: memoTx,
      updprogramCd: updprogramCd,
      updcounterNr: updcounterNr
    };

    return this.http.put(url, jsonInput);
  }

  upload(file: File, ownerId: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/excelupload/${ownerId}`;
    const formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    const header = {
      'Accept': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    };
    return this.http.post(url, formData, header);
  }

  //出荷引当取消
  cancelapply(selectItems: object[], updprogramCd: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/cancelapply`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < selectItems.length; i++) {
      jsonUnit.push({
        shiphId: selectItems[i]['shiphId'],
        ownerId: selectItems[i]['ownerId']
      });
    }
    const jsonInput: object = { selectItems: jsonUnit, updprogramCd: updprogramCd };
    return this.http.post(url, jsonInput);
  }

  //出荷保留
  reserve(selectItems: object[], updprogramCd: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/reserve`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < selectItems.length; i++) {
      jsonUnit.push({
        shiphId: selectItems[i]['shiphId'],
        ownerId: selectItems[i]['ownerId']
      });
    }
    const jsonInput: object = { selectItems: jsonUnit, updprogramCd: updprogramCd };
    return this.http.post(url, jsonInput);
  }

  //出荷保留取消
  resetreserve(selectItems: object[], updprogramCd: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/resetreserve`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < selectItems.length; i++) {
      jsonUnit.push({
        shiphId: selectItems[i]['shiphId'],
        ownerId: selectItems[i]['ownerId']
      });
    }
    const jsonInput: object = { selectItems: jsonUnit, updprogramCd: updprogramCd };
    return this.http.post(url, jsonInput);
  }

  //出荷キャンセル
  cancel(selectItems: object[], updprogramCd: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/cancel`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < selectItems.length; i++) {
      jsonUnit.push({
        shiphId: selectItems[i]['shiphId'],
        ownerId: selectItems[i]['ownerId']
      });
    }
    const jsonInput: object = { selectItems: jsonUnit, updprogramCd: updprogramCd };
    return this.http.post(url, jsonInput);
  }

  //出荷キャンセル取消
  resetcancel(selectItems: object[], updprogramCd: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/resetcancel`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < selectItems.length; i++) {
      jsonUnit.push({
        shiphId: selectItems[i]['shiphId'],
        ownerId: selectItems[i]['ownerId']
      });
    }
    const jsonInput: object = { selectItems: jsonUnit, updprogramCd: updprogramCd };
    return this.http.post(url, jsonInput);
  }

  //出荷完了
  // complete(selectItems: object[], updprogramCd: string): Promise<any> {
  //   const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/complete`;
  //   const jsonUnit: object[] = [];
  //   for (let i = 0; i < selectItems.length; i++) {
  //     jsonUnit.push({
  //       picknoCd: selectItems[i]['picknoCd']
  //     });
  //   }
  //   const jsonInput: object = {
  //     selectItems: jsonUnit,
  //     ownerId: selectItems[0]['ownerId'],
  //     updprogramCd: updprogramCd
  //   };
  //   return this.http.post(url, jsonInput);
  // }

  //出荷完了(Spring)
  completeByShiphIdList(selectItems: object[], updprogramCd: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/complete`;

    const jsonInput: object = {
      selectItems: selectItems,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);
  }

  //実績送信
  sendResult(selectItems: object[], updprogramCd: string, shipDateStart: string, shipDateEnd: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.resultmailsendApiUrl}`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < selectItems.length; i++) {
      jsonUnit.push({
        ownerId: selectItems[i]['ownerId']
      });
    }
    const jsonInput: object = { selectItems: jsonUnit, updprogramCd: updprogramCd, shipDateStart: shipDateStart, shipDateEnd: shipDateEnd };
    return this.http.put(url, jsonInput);
  }

  updateShipdate(shipDate: Date, selectItems: object[], updprogramCd: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/updateshipdate`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < selectItems.length; i++) {
      jsonUnit.push(selectItems[i]['shiphId']);
    }
    const jsonInput: object = { shipDate: shipDate, selectItems: jsonUnit, updprogramCd: updprogramCd };
    return this.http.post(url, jsonInput);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/ship/ship.service.ts